import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Clock } from 'lucide-react';
export function MobileOfferBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Check if we're on desktop (768px+ = md breakpoint)
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    if (mediaQuery.matches) return;
    let scrollTimer: ReturnType<typeof setTimeout> | null = null;
    let hasScrolled = false;
    const handleScroll = () => {
      if (hasScrolled || isDismissed) return;
      hasScrolled = true;
      // Show banner 5 seconds after first scroll
      scrollTimer = setTimeout(() => {
        setIsVisible(true);
      }, 5000);
      // Remove listener after first scroll detected
      window.removeEventListener('scroll', handleScroll);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimer) clearTimeout(scrollTimer);
    };
  }, [isDismissed]);
  const handleCTAClick = () => {
    // Fire Meta Pixel event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-203">
      {isVisible && !isDismissed && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 28,
      stiffness: 300
    }} className="fixed top-0 left-0 right-0 z-[90] md:hidden" data-id="element-204">
          <div className="bg-[#2d2d2d]/90 backdrop-blur-md border-b border-[#9d4b6b]/30 px-4 py-3" data-id="element-205">
            <div className="flex items-center gap-3 max-w-lg mx-auto" data-id="element-206">
              {/* Offer text + price */}
              <div className="flex-1 min-w-0" data-id="element-207">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-208">
                  <Clock className="w-3 h-3 text-[#d4a5a5] flex-shrink-0" data-id="element-209" />
                  <span className="text-[11px] text-[#d4a5a5] font-medium uppercase tracking-wide truncate" data-id="element-210">
                    Oferta por Tiempo Limitado
                  </span>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-211">
                  <span className="text-white font-bold text-lg leading-none" data-id="element-212">
                    $12.99
                  </span>
                  <span className="text-gray-400 text-xs line-through" data-id="element-213">
                    $49.99
                  </span>
                </div>
              </div>

              {/* CTA Button */}
              <button onClick={handleCTAClick} className="flex-shrink-0 bg-[#9d4b6b] hover:bg-[#b85d7f] active:scale-95 text-white text-xs font-bold py-2.5 px-4 rounded-full transition-all duration-200 shadow-lg shadow-[#9d4b6b]/30" data-id="element-214">
                Ver Oferta
              </button>

              {/* Dismiss */}
              <button onClick={handleDismiss} className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-gray-500 hover:text-white hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-215">
                <X className="w-3.5 h-3.5" data-id="element-216" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}